import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './static/css/typography.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { rootStoreState, RootStoreContext } from './state/rootStore';
import { ThemeProvider } from '@material-ui/core';
import theme from './theme';

ReactDOM.render(
    <React.StrictMode>
        <RootStoreContext.Provider value={rootStoreState}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </RootStoreContext.Provider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
